<script >
import config from "../config";
import { getQueryString } from '@/utils/common'
import { storage } from '@/utils/storage'
import { cookie } from '@/utils/cookie'
import { getAdvInfo } from '@/api/admin'
export default {
  name:"",
  data() {
    return {
      ifFilter:false,
      svapid:'',
      param:{
        keyWords:''
      },
      articleList:[
        {}
      ]
    }
  },
    mounted() {
      const svapid = getQueryString('svapid') ||  (config && config.svapid)
      const token = getQueryString('token') || storage.get('token')
      this.init(svapid,token)
    },
  methods: {
    async init(svapid,token){
      this.svapid = svapid
      if (this.svapid) {
        await this.fetchAndCacheAdvInfo(svapid)
        if (token){
          storage.set("token",token)
        }else {

          // 未登录：跳转登录页（带上回跳地址）
          this.redirectToAuthLogin({ svapid: this.svapid,appid:storage.get("appid") })
        }
      }

    },
    async fetchAndCacheAdvInfo (svapid) {
      try {
        const res = await getAdvInfo({ svapid })
        const adv = (res && res.data) ? res.data : (res || {})
        cookie.set('svapid', svapid, { days: 31, path: '/' })
        cookie.set('advance', JSON.stringify(adv || {}), { days: 31, path: '/' })
        storage.set('appid', adv.appid)
      } catch (e) {
        // ignore cache errors
        // ignore cache errors
      }
    },
    redirectToAuthLogin({ svapid,appid } = {}) {
      const redirectUrl = this.buildMainLiaoUrl(svapid)
      try {
        const loginUrl =
          config.loginUrl +
          '?redirectUrl=' +
          encodeURIComponent(redirectUrl) +
          '&svapid=' +
          encodeURIComponent(svapid || '') +
          '&appid=' +
          encodeURIComponent(appid || '')
        window.location.replace(loginUrl)
        return
      } catch (e) {
        // fallthrough
      }


    },
    buildMainLiaoUrl(svapid) {
      return window.location.origin +'/mainLiao?svapid=' + encodeURIComponent(svapid || '') + '&time=' + encodeURIComponent( Date.now().toString())
    }
  }
}
</script>

<template>
  <div class="xinliao-wrapper">
        <div class="xinliao-content">
          <div class="tabs">
            <span class="tab active">我的文章</span>
            <span class="tab">会员专辑(包月包时)</span></div>
          <div class="list-wrapper">
            <div class="l_search">
              <div class="l_s_filter" @click="ifFilter =!ifFilter">全部料
                <i class="cubeic-select"></i></div>
              <div class="l_s_search">
                <div>
                  <div class="searchBar">
                    <div style="width: 100%;">
                      <cube-input v-model="param.keyWords"  placeholder="输入标题搜索"  class="searchbook"></cube-input>
<!--                      <div class="cube-input searchbook">-->
<!--                        <input type="text" placeholder="输入标题搜索" clearable="true" class="cube-input-field">-->
<!--                      </div>-->
                    </div>
                    <div class="searchBtn">
                      <span class="cubeic-search"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l_filter" v-if="ifFilter">
                <div class="content">
                  <div class="selected">
                    <div class="item active">全部料</div>
                    <div class="item">返还料</div>
                    <div class="item">普通料</div></div>
                </div>
              </div>
            </div>
            <div class="l_content">
<!--              <div class="scroll-list-wrap">-->
<!--                <cube-scroll-->
<!--                  ref="scroll"-->
<!--                 >-->
<!--                  ... // 自定义内容-->
<!--                </cube-scroll>-->
<!--              </div>-->
              <div class="cube-scroll-wrapper scroll-list">
                <div class="cube-scroll-content" style="transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1); transition-duration: 0ms; transform: translate(0px, 0px) scale(1) translateZ(0px);">
                  <div class="cube-scroll-list-wrapper" style="min-height: 616px;">
                    <div class="article">
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/gongkai.png" alt="" class="sellStatus gonkai">
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:10</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期牛小*3D综合精选</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">免费</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">1</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn active">取消置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/gongkai.png" alt="" class="sellStatus gonkai">
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:00:54</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第26055期牛小*P3综合精选</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">免费</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn active">取消置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:14</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期吾乃神算3D推荐==五组四码复试</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥58</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:14</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期白晓生3D推荐三注《四码复试》</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥68</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:14</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期老鬼头==每日推荐3D双胆</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥38</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:13</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期过海八仙3D推荐《五注组选》</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥88</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:13</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期猛*男每日3D推荐 《三组双飞》送胆码</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥68</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:13</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期天下有敌3D精选推荐《五码复试》</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥68</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:13</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期秦时明月3D推荐三注《四码复试》</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥68</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                      <div>
                        <div class="publish-item">
                          <div class="publishStatus">
                            <!----></div>
                          <!---->
                          <!---->
                          <img src="https://oss.zhishijingling.com/jinriyouliao/list/zaishou.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time">
                            <div style="display: flex; align-items: center;">
                              <time>发布于03-05 22:01:13</time>
                              <div class="i_sort">
                                <div class="i_s_btn">排序</div>
                                <!----></div>
                            </div>
                            <!---->
                            <!----></div>
                          <!---->
                          <div class="p_title">
                            <!---->
                            <div class="p_t_name">
                              <div>
                                <!---->
                                <span>第2026055期同富同贵推荐3D每日=五码复试</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <!----></div>
                            <div class="p_t_price">￥58</div></div>
                          <div class="p_footer">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">0</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">0</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn">置顶</div>
                            <div class="oBtnShortSj">下 架</div>
                            <!---->
                            <div class="oBtnShort">加标签</div>
                            <!---->
                            <!---->
                            <img src="https://oss.zhishijingling.com/jinriyouliao/list/delete.png" alt="" class="oDelete"></div>
                        </div>
                      </div>
                    </div>
                    </div>
                  <div class="article">
                    <div index="0">
                      <div class="content">
                        <!---->
                        <img src="https://oss.zhishijingling.com/jinriyouliao/list/xiajia.png" alt="" class="sellStatus">
                        <div class="c_time">发布于05-13 19:59:56
                          <!----></div>
                        <div class="c_header">
                          <div class="c_content">
                            <div class="c_h_left">
                              <img src="http://oss.zhishijingling.com/haoliaodata/2024-05-13/049f04e648ee4be0824fd1471c7fb7471715601534550_605.jpg"></div>
                            <div class="c_h_right">
                              <div class="c_h_r_title">牛彩转去
                                <span class="tag month">包月</span></div>
                              <div class="c_h_r_total">共0篇文章</div></div>
                          </div>
                          <div class="c_h_right">
                            <img src="https://oss.zhishijingling.com/jinriyouliao/right.png"></div>
                        </div>
                        <div class="total">
                          <div class="t_item">
                            <div class="t_i_title">累计查看(人)</div>
                            <div class="t_i_number">0</div></div>
                          <div class="t_item">
                            <div class="t_i_title">累计购买(人)</div>
                            <div class="t_i_number">0</div></div>
                          <div class="t_item">
                            <div class="t_i_title">累计收款(元)</div>
                            <div class="t_i_number" style="color: rgb(247, 73, 5);">0</div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cube-pullup-wrapper">
                    <div class="before-trigger">
                      <span></span>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
        <!---->
        <div>
          <bottom-tab-bar />
        </div>
      </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/components/mainLiao.vue